import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: "50px",
    margin: "2%",
    textAlign:'center'
  },
  h2: {
    paddingBottom: "2%",
    color: "#fff",
  },
  img: {
    width: "15%",

    objectFit: "cover",
    [theme.breakpoints.down("md")]: {
      width: "80%",
    },
  },
  p: {
    margin: "1% auto",
    width: "85%",
    display:"inline-block",
    color: "#fff",
  },
}));

export default function ActionAreaCard({title,link,alt,desc}) {
  var style=useStyles()
  return (
    <Link to={"/category-details"} state={{ name: title }}>
      <Card
        sx={{ maxWidth: 345, background: "#124076" }}
        className={style.card}
      >
        <CardActionArea>
          <CardMedia
            component="img"
            height="140"
            className={style.img}
            image={link}
            alt={alt}
          />
          <CardContent>
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              className={style.h2}
            >
              {title}
            </Typography>
            <Typography variant="body2" className={style.p}>
              {desc}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Link>
  );
}
